import { render, staticRenderFns } from "./RootserversOverview.vue?vue&type=template&id=ba7e58f2&"
import script from "./RootserversOverview.vue?vue&type=script&lang=js&"
export * from "./RootserversOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports